import React, {useContext, useEffect, useState} from 'react';
import {Descriptions} from "antd";

import './applicationDetail.scss';

import ApplicationDetailTemplate from "../../../components/applicationDetailTemplate/applicationDetailTemplate";
import moment from "moment";
import {userDetail} from "../../../apis/result";
import {AppContext} from "../../../App";
import {TIME_FORMAT} from "../../../utils/constants";

function UserApplicationDetailPage() {
    const {setLoading} = useContext(AppContext)
    const [data, setData] = useState({
        sections: []
    });

    useEffect(() => {
        getApplicationDetail();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getApplicationDetail = async () => {
        setLoading(true)
        try {
            const res = await userDetail();
            if (res.error) {
                throw new Error(`${res.error.msgCode} - ${res.error.message}`);
            } else {
                setData({
                    ...data,
                    applicationNumber: res.applicationNumber,
                    applicationTimestamp: res.applicationTimestamp,
                    sections: res.sections
                })
            }
        } catch (e) {
            console.error(e);
        }finally {
            setLoading(false)
        }
    };

    return (
        <div className='application-detail-page'>
            <Descriptions title="申請狀況">
                <Descriptions.Item label="申請編號">{data.applicationNumber}</Descriptions.Item>
                <Descriptions.Item label="申請遞交時間">{moment(data.applicationTimestamp).format(TIME_FORMAT)}</Descriptions.Item>
            </Descriptions>
            <ApplicationDetailTemplate id={data.applicationNumber} sections={data.sections}/>
        </div>
    )

}



export default UserApplicationDetailPage;
